import { SocketIoModule } from 'ngx-socket-io';
import { NgModule } from '@angular/core';
import { ChatSocket } from '@shared/services/websocket/custom_sockets/chat.socket';
import { WebsocketService } from '@shared/services/websocket/websocket.service';
import { NotificationSocket } from "@shared/services/websocket/custom_sockets/notification.socket";

@NgModule({
  exports: [SocketIoModule],
  providers: [ChatSocket, NotificationSocket, WebsocketService],
})
export class SocketModule {}
